import React from 'react';
import useAppStore from '../../store';

// UI control modes are distinct from AGENT_STATUSES (lib/constants/statuses.js):
// each mode maps onto the status the agent should run under. Manual means a
// human approves every step — modeled as 'queued' (work waits for a trigger).
const CONTROL_MODES = [
  { id: 'active', label: 'Active', status: 'running' },
  { id: 'paused', label: 'Paused', status: 'idle' },
  { id: 'autonomous', label: 'Autonomous', status: 'autonomous' },
  { id: 'manual', label: 'Manual', status: 'queued' }
];

function AgentControls({ agent }) {
  const updateAgent = useAppStore((state) => state.updateAgent);
  const activeMode = CONTROL_MODES.find((mode) => mode.status === agent.status)?.id
    || 'active';

  const handleSelect = (modeId) => {
    const mode = CONTROL_MODES.find((entry) => entry.id === modeId);
    updateAgent(agent.id, { status: mode.status });
  };

  return (
    <div
      aria-label={`${agent.name} run mode`}
      className="control-segment"
      role="radiogroup"
    >
      {CONTROL_MODES.map((mode) => (
        <button
          aria-checked={activeMode === mode.id}
          className={`control-segment-item ${activeMode === mode.id ? 'is-active' : ''}`}
          key={mode.id}
          onClick={() => handleSelect(mode.id)}
          role="radio"
          type="button"
        >
          {mode.label}
        </button>
      ))}
    </div>
  );
}

export default AgentControls;
